<template>
    <KButton
        v-editable="blok"
        :label="blok.text"
        @click="buttonClick"
    >
        <template
            v-if="blok.icon && icons[blok.icon]"
            #icon-end
        >
            <Icon :name="icons[blok.icon]" />
        </template>
    </KButton>
</template>

<script setup>
import { KButton } from '@vemedia/karibu'

const { blok } = defineProps({
    blok: {
        type: Object,
        default: () => ({}),
    },
})

const icons = {
    'arrow-right': 'tabler:arrow-right',
}

const { capture } = useTracking()

function buttonClick() {
    capture('affiliate_click', {
        placement: 'button',
        label: blok.text,
        url: blok.link,
    })
    window.open(blok.link, '_blank')
}
</script>
